const DetailCard = ({ className, children }) => {
  return (
    <div
      className={`bg-white border border-solid border-gray-600 rounded-lg ${className}`}
    >
      {children}
    </div>
  );
};

export default DetailCard;